<template>
  <div v-if="currentQuestion">
    <HTTPresponse :alert="httpalert" @changeHTTPBoxState="HTTPState"></HTTPresponse>
    <div class="box-outlined">
      <v-layout
        d-flex
        row
        ma-0
        align-center
        justify-space-between
        class="box-header"
      >
        <v-flex xs12 sm7 lg8>
          <h2
            class="box-header-item mb-3 mb-md-0"
            v-html="currentQuestion.info[`title_${$i18n.locale}`]"
          ></h2>
        </v-flex>
        <v-divider vertical inset></v-divider>
        <v-flex xs12 sm3 lg2>
          <p class="box-header-item ma-0 text-center d-flex align-center">
            <span v-if="inspector" class="h2 mr-1" v-html="currentQuestion.vetted.point"></span>
            <span v-else class="h2 mr-1" v-html="currentQuestion.done.point"></span>
            <strong>{{ $tc("survey-question-block.point",
                           parseInt(currentQuestion.done.point) == 1 ||
                           parseInt(currentQuestion.done.point) == 0 ?
                           1 : parseInt(currentQuestion.done.point)) }}</strong>
          </p>
        </v-flex>
      </v-layout>

      <div class="box-content pa-0">
        <!-- check if modules is not empty -->
        <template v-if="rebuildInputs && rebuildInputs.length > 0">
          <v-layout v-if="inspector">
            <v-flex xs2 mt-5 class="text-center">
              <small class="dark--text">{{ $t("validate-audit.title-2") }}</small>
            </v-flex>
          </v-layout>
          <v-layout
            v-for="input in rebuildInputs"
            :key="input.id"
            class="box-content-item"
            d-block
            d-md-flex
            row
            ma-0
            align-center
            justify-space-between
            xs12
            lg10
            :style="{ background: input.bg||input[0].bg }"
          >
            <!-- <pre>{{input}}</pre> -->
            <template v-if="inspector && input.type !== 'legend'">
              <v-layout
                ma-0
                pa-0
                style="position: relative;"
                justify-space-between
              >
                <Inspector
                  :answerid="answerid"
                  :input="input"
                  @inputUpdated="inputChange"></Inspector>
                <!-- Now loop trought the modules (like input in a question) -->
                <v-flex xs10>
                  <Inputs
                    :answerid="answerid"
                    :path="`${question.path}|${question.id}`"
                    :input="input"
                    inspector
                    disabledInputs
                    :maxDerogations="maxDerogations"
                    :doneDerogations="doneDerogations"
                    @inputUpdated="inputChange"
                    class="px-4"
                  ></Inputs>
                </v-flex>
              </v-layout>
            </template>
            <template v-else>
              <v-flex
                xs12
                lg10
                offset-lg2
                style="position: relative;"
              >
                <!-- Now loop trought the modules (like input in a question) -->
                <Inputs
                  :answerid="answerid"
                  :maxDerogations="maxDerogations"
                  :doneDerogations="doneDerogations"
                  :path="`${question.path}|${question.id}`"
                  :input="input"
                  :disabledInputs="disabledInputs"
                  @inputUpdated="inputChange"
                  class="px-4"
                ></Inputs>
              </v-flex>
            </template>
              
          </v-layout><!-- End modules loop -->
          <div v-if="inspector" class="text-center w-100 py-5">
            <v-btn
              :elevation="0"
              rounded
              :outlined="inspectorNote"
              color="primary"
              @click="inspectorNote = !inspectorNote"
            >{{ $t("validate-audit.btn-1") }}</v-btn>
          </div>
        </template>
        <template v-else>
          <v-layout
            d-block
            d-md-flex
            row
            ma-0
            align-center
            justify-space-between
            xs12
            lg10
            offset-lg2
          >
            Sorry there is no question found
          </v-layout>
        </template>
      </div>
    </div>

    <InspectorNote
      v-if="inspectorNote"
      :answerid="answerid"
      :question="question"
      :infoQuestion="currentQuestion.info"
      class="mt-4"></InspectorNote>

    <div class="box mt-4">
      <AskBox
        :noButton="inspector && noButton ? true : false"
        :question="question"
        :keywordid="$route.params.sequenceid"
        :inspector="inspector"></AskBox>
    </div>

    <!-- Navigation buttons -->
    <div
      v-if="!noButton &&
            (currentQuestion.prev.type === 'surveyq' ||
            currentQuestion.next.type === 'surveyq')"
      class="overflow-hidden mt-8"
    >
      <v-btn
        v-if="currentQuestion.prev.type === 'surveyq'"
        outlined
        rounded
        color="primary"
        class="float-left"
        @click="changeTabVal({type: 'question', object: currentQuestion.prev})"
      >
        {{ $t("survey-question-block.btn-1") }}
      </v-btn>
       <v-btn
        v-else-if="currentQuestion.prev.type === 'none' && currentQuestion.up.type === 'survey'"
        outlined
        rounded
        color="primary"
        class="float-left"
        @click="changeTabVal({type: 'sequence', object: currentQuestion.up})"
      >
        {{ $t("survey-question-block.btn-1") }}
      </v-btn>
      <!-- <pre>{{currentQuestion}}</pre> -->
      <v-btn
        v-if="currentQuestion.next.type === 'surveyq'"
        outlined
        rounded
        color="primary"
        class="float-right"
        @click="changeTabVal({type: 'question', object: currentQuestion.next})"
      >
        {{ $t("survey-question-block.btn-2") }}
      </v-btn>
      <v-btn
        v-else-if="currentQuestion.next.type === 'none'"
        outlined
        rounded
        color="primary"
        class="float-right"
        @click="changeNextSeq"
      >
        {{ $t("survey-question-block.btn-2") }}
      </v-btn>
      <!-- <pre>{{currentQuestion}}</pre> -->
      <!-- <button v-else @click="test">test</button>
      <pre v-if="testvar">{{testvar}}</pre> -->
    </div>
    <!-- <pre>{{currentQuestion}}</pre> -->
  </div>
</template>

<script>
import { showQuestion } from '@/js/survey/showQuestion'
import { showSequence  } from '@/js/survey/showSequence'
import Inputs from '@/components/audits/survey/Inputs'
import Inspector from '@/components/audits/survey/inputs/Inspector'
import InspectorNote from '@/components/audits/survey/InspectorNote'
import AskBox from '@/components/audits/survey/AskBox'
import HTTPresponse from '@/components/app/HTTPresponse'

export default {
  props: {
    question: Object,
    answerid: String,
    maxDerogations: Number,
    doneDerogations: Number,
    disabledInputs: {
      type: Boolean,
      default: false
    },
    noButton: Boolean,
    inspector: {
      type: Boolean,
      default: () => false
    }
  },

  components: {
    Inputs: Inputs,
    Inspector: Inspector,
    InspectorNote: InspectorNote,
    AskBox: AskBox,
    HTTPresponse: HTTPresponse
  },

  data () {
    return {
      currentQuestion: null,
      inspectorNote: false,

      httpalert: false
      // renderComponent: true
    }
  },

  async created () {
    await this.rendreQuestion()
  },

  methods: {
    changeTabVal (value) {
      this.$emit('tabChnage', value, true)
    },
    inputChange () {
      this.rendreQuestion()
      this.$emit('updateSubmitBtn')
      this.$emit('updateSeq')
    },
    async rendreQuestion () {
      // if (!this.$store.getters['auth/isAuthenticated']) return

      this.$root.$on('enableInterceptor')
      // this.$emit('disableInterceptor')

      // load here
      // ...
      const params = {
        options: this.inspector ? 'json+conf' : null,
        answerid: this.answerid,
        path: this.question.path,
        questionid: this.question.id,
        key: this.inspector && this.$route.params.validkey ?
             this.$route.params.validkey : this.$store.state.auth.token
      }
      await showQuestion(params)
        .then(response => {
          this.currentQuestion = response
          // this.$root.enableInterceptor()
          this.$root.$on('enableInterceptor')
        })
        .catch(() => {
          this.httpalert = true
          setTimeout(() => {
            this.httpalert = false
          }, 4000)
          this.$root.$on('enableInterceptor')
        })
    },

    changeNextSeq () {
      const params = {
        answerid: this.answerid,
        path: this.currentQuestion.up.path,
        sequenceid: this.currentQuestion.up.id,
        key: this.inspector && this.$route.params.validkey ?
             this.$route.params.validkey : this.$store.state.auth.token
      }
      showSequence(params)
        .then(response => {
          if (response.next.type === 'none') return
          this.$emit('tabChnage', {type: 'sequence', object: response.next}, true)
        })
        .catch(() => {
          this.httpalert = true
          setTimeout(() => {
            this.httpalert = false
          }, 4000)
        })
    },

    HTTPState (value) {
      this.httpalert = this.value
    }
  },

  mounted () {
    this.$root.$on('disableInterceptor')
  },

  computed: {
    rebuildInputs () {
      var inputs = []
      let backgroundColor = '#FFFFFF'
      let padding = false

      this.currentQuestion.modules.forEach(async input => {
        const type = input.type

        // check if type is radio or pulldown
        if (type.indexOf('radio') > -1 || type.indexOf('pulldown') > -1) {
          const exist = type in inputs
          if (exist === false) { // if key doesn't exist in table create it then push input
            inputs.push(inputs[type] = [])

            input.bg = backgroundColor
            if (padding) input.padding = padding

            inputs[type].push(input)

            if (input.continued !== 'yes') {
              padding = false
              backgroundColor = backgroundColor === '#FFFFFF' ? 'rgba(243, 244, 249, 0.4)' : '#FFFFFF'
            } else { padding = true }
          } // else if key exist just push in input
          else {
            inputs[type].push(input)
          }
        } else {
          input.bg = backgroundColor
          if (padding) input.padding = padding

          inputs.push(input)

          if (input.continued !== 'yes') {
            padding = false
            backgroundColor = backgroundColor === '#FFFFFF' ? 'rgba(243, 244, 249, 0.4)' : '#FFFFFF'
          } else { padding = true }
        }
      })
      return inputs
    }
  }
}
</script>
